<template>
  <div>
    <div class="novatable-wrapper">
      <table class="novatable" :class="tableClass">
        <thead>
          <slot name="columns">
            <th v-for="(column, key) in columns" :key="key">
              <div class="novatable-header">
                <div v-if="!column.lang" class="novatable-header-title">
                  {{
                    (column.key + (column.object ? "_" + column.object : ""))
                      | setText(column.title)
                  }}
                </div>
                <div v-else class="novatable-header-title">
                  {{ column.label | setText }}
                </div>
                <div v-if="column.sortBy" class="novatable-header-sort hide">
                  <span
                    :style="{
                      opacity:
                        sort.orderType === 'ACS' && sort.orderBy === column.sortBy
                          ? 1
                          : 0.4,
                    }"
                    class="ti-arrow-circle-up"
                  ></span>
                  <span
                    :style="{
                      opacity:
                        sort.orderType === 'DESC' &&
                        sort.orderBy === column.sortBy
                          ? 1
                          : 0.4,
                    }"
                    class="ti-arrow-circle-down"
                  ></span>
                </div>
              </div>
            </th>
          </slot>
        </thead>
        <!-- v-model="dataArray" -->
        
        <tbody
          :move="onMove"
          v-if="dataArray.length"
          :tag="'tbody'"
          @change="positionItem"
        >
        <tr width="auto" 
          v-for="(item, index) in data" 
          :key="index"
          :class="{
            'have-remove': columns[columns.length-1].remove,
            'have-detail': columns[columns.length-1].detail,
          }">
          <td 
            v-for="(column, index) in columns" 
            :key="index" 
            :class="`novatable-${column.key}`">
            <div class="novatable-btns text-right" v-if="column.remove || column.detail">
              <button
                v-if="column.detail === true"
                @click="openObject(item, card)"
                class="btn-edit btn-inlist"
                title="Редактировать"
              >
              <svg class="svg-pencil" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 23 23" fill="currentColor">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7549 -0.0224609C18.9795 -0.0224609 19.2041 -0.0224609 19.4287 -0.0224609C19.9695 0.0756857 20.4487 0.307782 20.8662 0.673828C21.4291 1.22168 21.9756 1.7832 22.5059 2.3584C22.7289 2.67693 22.8861 3.02134 22.9775 3.3916C22.9775 3.72103 22.9775 4.05046 22.9775 4.37988C22.8675 4.76477 22.6953 5.12415 22.4609 5.45801C21.8164 6.11 21.1651 6.75387 20.5068 7.38965C18.8593 5.71968 17.2121 4.06505 15.5654 2.42578C16.2093 1.7819 16.8532 1.13802 17.4971 0.494141C17.8788 0.219935 18.2981 0.0477344 18.7549 -0.0224609Z"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.741211 22.9775C0.576496 22.9775 0.411784 22.9775 0.24707 22.9775C0.142253 22.9027 0.052409 22.8128 -0.0224609 22.708C-0.0224609 22.5433 -0.0224609 22.3786 -0.0224609 22.2139C0.463046 20.3319 0.949698 18.4451 1.4375 16.5537C5.66766 12.3236 9.89777 8.09344 14.1279 3.86328C14.1729 3.83333 14.2178 3.83333 14.2627 3.86328C15.8724 5.47297 17.4821 7.0827 19.0918 8.69238C19.1218 8.73731 19.1218 8.78223 19.0918 8.82715C14.8616 13.0573 10.6315 17.2874 6.40137 21.5176C4.50993 22.0054 2.62319 22.492 0.741211 22.9775Z"/>
              </svg>
              <!-- <span class="m-l-2 btn-edit-title">Редактировать</span> -->
              </button>
              <button
                v-if="column.remove === true"
                @click="removeItem(item.id)"
                class="btn-del ml-1 btn-inlist"
                title="Удалить"
              >
                <svg width="20" height="20" viewBox="0 0 25 25" fill="#E11E55" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.37392 -0.0244141C11.1083 -0.0244141 13.8427 -0.0244141 16.577 -0.0244141C17.2595 0.161628 17.6908 0.601079 17.871 1.29395C17.8954 2.14014 17.9036 2.9865 17.8954 3.83301C19.7672 3.82487 21.639 3.83301 23.5106 3.85742C24.2746 4.15671 24.4943 4.68568 24.1698 5.44434C23.9774 5.73179 23.7089 5.88638 23.3642 5.9082C22.8599 5.93262 22.3553 5.94072 21.8505 5.93262C21.3569 11.8096 20.8442 17.6853 20.3124 23.5596C20.1432 24.2739 19.7119 24.7459 19.0184 24.9756C14.6565 24.9756 10.2945 24.9756 5.93251 24.9756C5.23906 24.7459 4.80775 24.2739 4.63857 23.5596C4.10676 17.6853 3.59407 11.8096 3.10048 5.93262C2.59566 5.94072 2.09111 5.93262 1.58681 5.9082C0.715364 5.68682 0.44681 5.15786 0.781145 4.32129C0.945462 4.09246 1.16519 3.93784 1.44033 3.85742C3.312 3.83301 5.18373 3.82487 7.05556 3.83301C7.04741 2.9865 7.05556 2.14014 7.07997 1.29395C7.2602 0.601079 7.6915 0.161628 8.37392 -0.0244141ZM9.10634 2.02637C11.3524 2.02637 13.5985 2.02637 15.8446 2.02637C15.8446 2.62858 15.8446 3.2308 15.8446 3.83301C13.5985 3.83301 11.3524 3.83301 9.10634 3.83301C9.10634 3.2308 9.10634 2.62858 9.10634 2.02637ZM5.15126 5.93262C10.0341 5.93262 14.9169 5.93262 19.7997 5.93262C19.2952 11.5964 18.7906 17.2605 18.286 22.9248C14.4123 22.9248 10.5386 22.9248 6.66493 22.9248C6.16572 17.2595 5.66113 11.5954 5.15126 5.93262Z"/>
                </svg>
              </button>
            </div>
            <div v-else-if="column.inputSet === true">
              <input
                class="input"
                v-model="item[column.key]"
                @input="setUpdate(item, column.key)"
              />
            </div>
            <div v-else-if="column.key === 'path'">
              <a :href="item[column.key]" target="_blank">{{
                "Скачать" | setText("download")
              }}</a>
            </div>
            <div v-else-if="column.input">
              <span>
                <input
                  v-model="item[column.key]"
                  :type="column.input"
                  class="form-control"
                />
              </span>
            </div>
            <div v-else-if="column.checkbox === true">
              <checkbox
                v-if="!simple"
                v-model="val"
                :value="item.id"
                :id="`check_${item.id}`"
              >
                <span v-html="itemValue(item, column)"></span>
              </checkbox>
              <div v-if="simple" class="radiobox radio-style-1 w-10">
                <input
                  v-if="simple"
                  :id="card + 'item-' + item.id"
                  :value="item.id"
                  :name="card ? card : 'selector'"
                  v-model="val"
                  type="radio"
                />
                <label :for="card + 'item-' + item.id">
                  <span v-html="itemValue(item, column)"></span>
                </label>
                <span class="radio-item">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <circle r="8" cx="50%" cy="50%" class="_circle-1"></circle>
                    <circle r="8" cx="50%" cy="50%" class="_circle-2"></circle>
                    <circle r="8" cx="50%" cy="50%" class="_circle-3"></circle>
                  </svg>
                </span>
              </div>
            </div>
            <div v-else-if="column.dateFormat === true">
              <span v-if="column.object && item[column.key][column.object]">
                {{ item[column.key][column.object] | dateFormat }}
              </span>

              <span v-else> {{ item[column.key] | dateFormat }}</span>
            </div>
            <div v-else-if="column.dateTimeFormat === true">
              <span v-if="column.object && item[column.key][column.object]">
                {{ item[column.key][column.object] | dateTimeFormat }}
              </span>
              <span v-else> {{ item[column.key] | dateTimeFormat }}</span>
            </div>
            <div v-else-if="column.image === true">
              <img
                v-if="itemValue(item, column)"
                :src="itemValue(item, column)"
                :alt="`img`"
                class="img"
              />
            </div>
            <div v-else-if="column.timer === true">
              <timer :item="item" />
            </div>
            <div v-else-if="column.subobject && column.object">
              {{ item[column.object][column.subobject][column["key"]] }}
            </div>
            <div v-else>
              <span
                v-if="
                  !column.key_type &&
                  column.object &&
                  column.key &&
                  item[column.key] &&
                  column['disableLink'] !== true
                "
                @click="
                  openObject(
                    item[column.key],
                    column.keyAs ? column.keyAs : column.key,
                    'item_'
                  )
                "
                class="link text-info"
              >
                {{ itemValue(item, column) }}
              </span>
              <span
                v-else-if="column.key_type && item[column.key]"
                @click="
                  openObject(
                    { id: item[column.key].id },
                    item[column.key_type],
                    'item_'
                  )
                "
                class="link text-info"
              >
                {{ itemValue(item, column) }} # {{ item[column.key_type] }}
              </span>
              <span v-else-if="column.key == 'phone'">{{ item.phone | phoneFormat }}</span>
              <span v-else-if="column.key == 'is_moderated'" class="fw-5">
                <span style="color: #30AB02;" v-if="item.is_moderated">Активен</span>
                <span style="color: #FF4C00;" v-else>Неактивен</span>
              </span>
              <span v-else-if="column.key == 'is_active'" class="fw-5">
                <span style="color: #30AB02;" v-if="item.is_active">Активен</span>
                <span style="color: #FF4C00;" v-else>Неактивен</span>
              </span>
              <span v-else>
                <span v-html="itemValue(item, column)"></span>
              </span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import draggable from "vuedraggable";
import timer from "../components/Timer";
import { errorNotify } from "@/plugins/functions";
export default {
  components: {
    timer,
    draggable,
  },

  data() {
    return {
      timerInput: {},
      noImage: require("@/assets/img/no-photo-available.png"),
      // val: [],
      sort: {
        orderBy: "id",
        orderType: "DESC",
      },
    };
  },
  name: "paper-table",
  props: {
    drag: {
      default: false,
    },
    card: {
      default: null,
    },
    additionalId: {
      default: null,
    },
    current_page: {
      default: 1,
    },
    columns: Array,
    data: Array,
    holidays: Object,
    type: {
      type: String,
      default: "striped",
    },
    itemLink: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    cardLink: {
      type: String,
      default: "",
    },
    simple: {
      default: false,
    },
    subTitle: {
      type: String,
      default: "",
    },
    removeItem: {
      default: function () {},
    },
    items: {
      default: function () {},
    },
    value: {
      default: function () {
        return [];
      },
    },
    dataObject: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    ...mapState(["languages"]),
    tableClass() {
      return `table-${this.type}`;
    },
    val: {
      get() {
        let val;
        if (!this.simple) {
          val = [];
          for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].id) {
              this.dataObject[this.value[i].id]["input_data"] =
                this.value[i].input_data;
              val.push(this.value[i].id);
            }
          }
        } else {
          val = this.value;
        }

        // console.log('object: ', this.dataObject);
        return val;
      },
      set(val) {
        let result;
        if (!this.simple) {
          result = [];
          for (let i = 0; i < val.length; i++) {
            if (this.dataObject[val[i]]) {
              result.push(this.dataObject[val[i]]);
            }
          }
        } else {
          result = [this.dataObject[val]];
        }
        //console.log(this.value);
        this.$emit("input", result);
      },
    },
    dataArray: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("changeData", val);
      },
    },
  },
  methods: {
    sortBy(column) {
      if (column.sortBy) {
        this.sort.orderType =
          this.sort.orderType === "ACS" && this.sort.orderBy === column.sortBy
            ? "DESC"
            : "ACS";
        this.sort.orderBy = column.sortBy;
        this.$emit("sortby", this.sort);
      }
    },
    openObject(item, card, prefix = "") {
      const element = `${prefix}${card}`;

      let link = item.id;

      if (this.additionalId) {
        link += "-" + this.additionalId;
      }

      let query = Object.assign({}, this.$route.query);
      if (query[element] == link) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = link;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },

    // change(e) {},
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },

    itemValue(item, column) {
      let key = column.key;

      let titleObject = item[key];

      if (column.image === true) {
        return item[key] ? item[key] : this.noImage;
      }

      if (typeof item[key] === "object" && item[key] !== null) {
        if (Array.isArray(titleObject) && titleObject.length) {
          return titleObject
            .map((elem) => {
              if (column.object) {
                if (column.key === "translations") {
                  if (
                    !this.languages[elem["locale"]] ||
                    !elem[column.object] ||
                    elem[column.object] === "null"
                  ) {
                    return null;
                  }
                  return (
                    (column.key === "translations"
                      ? ' <span class="text-info">' +
                        elem["locale"] +
                        ": </span>"
                      : "") + elem[column.object]
                  );
                } else {
                  return elem[column.object];
                }
              }
            })
            .filter((el) => {
              return el;
            })
            .join(`<br/>`);
        } else if (column.object && titleObject[column.object]) {
          return titleObject[column.object];
        } else {
          return "-";
        }
      } else if (typeof item[key] === "boolean") {
        return item[key] ? "+" : "-";
      }

      if (item[key.toLowerCase()] || item[key.toLowerCase()] === 0) {
        return item[key.toLowerCase()];
      }

      // if (column.object && column.objectDefault) {
      //   return column.objectDefault;
      // }

      return "-";
    },
    setUpdate(item, column) {
      let data = {};

      if (this.timerInput[item["id"]]) {
        clearTimeout(this.timerInput[item["id"]]);
        this.timerInput[item["id"]] = null;
      }
      this.timerInput[item["id"]] = setTimeout(() => {
        let url = `${this.itemLink}/${item["id"]}`;
        data[column] = item[column];
        // this.$loading(true);
        this.$http
          .put(url, data)
          .then((response) => {})
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally((res) => {
            // this.$loading(false);
          });
      }, 800);
    },
    positionItem(val) {
      if (val && val.moved) {
        let moved = val.moved;
        let elementId = moved.element.id;
        let oldIndex =
          (this.items.current_page - 1) * this.items.per_page +
          moved.oldIndex +
          1;
        let newIndex =
          (this.items.current_page - 1) * this.items.per_page +
          moved.newIndex +
          1;
        let url = `lessonplans/${elementId}?change_position=1`;
        let data = {
          newIndex,
          oldIndex,
        };
        this.$loading(true);
        this.$http
          .put(url, data)
          .then((response) => {})
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally((res) => {
            this.$loading(false);
          });
      }
    },
    onMove() {
      return this.drag;
    },
  },
};
</script>
<style lang="scss">
tr {
  &:last-child {
    padding-right: 100px;
  }
}

.table {
  .img {
    width: 35px;
    height: 35px;
    object-fit: contain;
  }
  .radiobox{
    label{
      width: 100%;
    }
  }
}
.radio-style-1{
  position: relative;
  input{
    display: none;
    &:checked{
      &~.radio-item{
        ._circle-2, ._circle-3{
          stroke-dasharray: 76.5;
          stroke-width: 2.5px;
        }
        &:before{
          transform: scale(1);
          // background-color: green;
        }
      }
    }
  }
  label{
    padding-left: 0;
    min-height: 20px;
    width: 100%;
    span{
      margin-left: 30px;
      // display: flex;
      // align-items: center;
    }
    &:hover{
      cursor: pointer;
    }
  }
  .radio-item{
    pointer-events: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: #8B77F1;
    position: absolute;
    left: 0;
    top: calc(50% - 10px);
    border-radius: 50%;
    &:before{
      transition: 0.3s ease;
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      left: calc(50% - 5px);
      top: calc(50% - 5px);
      background-color: currentColor;
      display: block;
      border-radius: 50%;
      transform: scale(0);
    }
    svg{
      display: block;
      width: 100%;
      height: 100%;
      fill: transparent;
      // transition: 0.3s ease;
    }
    circle{
      stroke-linecap: round;
      stroke-miterlimit: 1;
      stroke-linejoin: round;
    }
    ._circle-1{
        stroke: #d1d1d1;
        stroke-width: 1px;
        z-index: 0;
        // display: none;
      }
    ._circle-2, ._circle-3{
      stroke: currentColor;
      stroke-width: 0px;
      z-index: 1;
      stroke-dashoffset: 51;
      stroke-dasharray: 51;
      transition: 0.3s ease;
    }
    ._circle-3{
      transform: scale(-1);
      transform-origin: 50%;
    }
  }
  &:hover{
    ._circle-2{
      // stroke-dashoffset: -91.3;
      // transition: 5s steps(60, jump-none);
      // animation: circleRotate 1s linear infinite;
    }
  }
}
.radiobox {
  display: flex;
  align-items: center;
  & > {
    display: block;

    input {
      margin-right: 10px;
    }
  }
}
.table.nova-style{
  .table-header-sort{
    display: none;
  }
}
.control-item {
  min-width: 110px;
  max-width: 110px;
  width: 110px;
}
</style>
